import { defineMessages } from 'react-intl';

export const navItemsMessages = defineMessages({
    guideTab: {
        id: 'navItems.guideTab',
        defaultMessage: 'Guide',
        description:
            'Nav bar label for the care plan tab, shown in place of "Plan" to concierge GA users.',
    },
    useMobileAppCta: {
        id: 'navItems.useMobileAppCta',
        defaultMessage: 'Use Mobile App',
        description:
            'Button cta text to prompt the user to download the mobile app.',
    },
});
